import React, { useEffect, useState } from 'react'
import UturnArrowIcon from '../../../elements/icons/UturnArrowIcon';
import ModalActionButton from '../../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { createApplicationResponse } from '../../../../store/actions/applicationResponsesActions';
import { sanitizePayload, toTimeStamp } from '../../../../utils';
import Wysiwyg from '../../../elements/form/Wysiwyg';
import CloseIcon from '../../../elements/icons/CloseIcon';

const ApplicationResponse = ({description, closeFunction, parentResponse, reload, application}) => {
    const responsesSelector = useSelector(state => state.applicationResponses)
    const dispatch = useDispatch()

    const [responseMessage, setResponseMessage] = useState('');

    const pushResponse = () => {
        console.log('the response -> ', responseMessage)
        const payload = {
            response: responseMessage,
            responseTo: parentResponse._id
        }
        dispatch(createApplicationResponse(application._id, sanitizePayload(payload)))
    }

    const [addingResponse, setAddingResponse] = useState();

    useEffect(() => {

        if(responsesSelector.createdResponse !== null){
            setAddingResponse(false)
        }
        
        return () => {
            
        };
    }, [responsesSelector.createdResponse]);

    return (
        <div>
            <div className='mb-4 text-sm'>{description}</div>

            <div className='p-5 rounded bg-gray-100 text-black' dangerouslySetInnerHTML={{__html: parentResponse.response}} />
            <div className='px-5 text-right'>
                <p className='text-gray-600 text-sm mt-2'>{parentResponse.createdBy.name} - {toTimeStamp(parentResponse.createdAt)}</p>
                <p className='text-sm text-gray-600'>{parentResponse.responses.length} replies</p>
            </div>

            <button onClick={()=>{setAddingResponse(true)}} className='text-vcm-purple p-3 rounded bg-vcm-light-purple bg-opacity-50 mt-3 hover:text-vcm-purple transition duration-200 text-sm flex items-center gap-x-2'>Add a reply <UturnArrowIcon className={`w-4 h-4`} /></button>

            {addingResponse && <>
                <div className='w-full relative'>
                    <div className='absolute -top-[25px] right-0'>
                        <button onClick={()=>{setAddingResponse(false)}} className='flex items-center justify-center gap-x-2 text-gray-500 text-sm'>
                            <CloseIcon className={`w-4 h-4`} />
                            Cancel
                        </button>
                    </div>
                    <div className='borderless px-6'>
                        <Wysiwyg 
                            fieldTitle=""
                            initialValue={''}
                            updateValue={
                                (value)=>{
                                    setResponseMessage(value)
                                }
                            }
                        />
                    </div>
                </div>

                <div className="mt-8 flex flex-row-reverse gap-x-4">
                    <ModalActionButton
                        buttonLabel={`Post Response`}
                        buttonAction={()=>{pushResponse()}}
                        processing={responsesSelector.creatingResponse}
                    />

                    <button
                        type="button"
                        className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                        onClick={closeFunction}
                    >
                        Cancel
                    </button>
                    
                </div>
            </>}

            {parentResponse.responses.map((response, responseIndex) => (
                <div key={responseIndex} className='my-3'>
                    <div className={`p-5 rounded ${response.adminComment ? 'bg-vcm-light-purple bg-opacity-20' : 'bg-gray-100 text-black'}`} dangerouslySetInnerHTML={{__html: response.response}} />
                    <p className='text-gray-600 text-sm mt-2 ml-[20px]'>{response.createdBy.name} - {toTimeStamp(response.createdAt)}</p>
                </div>
            ))}
        </div>
    )
}

export default ApplicationResponse